import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import mixpanel from 'mixpanel-browser';
import { useCurrentOrderStudentId } from '../../../../../hooks/useCurrentOrderStudentId';
import { declinePreCartOfferProduct } from '../../../../../actions/v3Order';

const DeclinePreCartOfferProductButton = () => {
  const dispatch = useDispatch();
  const product = useSelector((state) => state.productConfig.currentProduct);
  const studentId = useCurrentOrderStudentId();

  if (!product) return null;

  return (
    <div
      className="bnl-product-config__button--cancel button bg--dark-grey"
      onClick={() => {
        mixpanel.track('Pre-Cart Offer Button Click', {
          Selection: 'Decline',
        });
        dispatch(declinePreCartOfferProduct(studentId, product.id, undefined));
      }}
    >
      No Thanks
    </div>
  );
};

export default DeclinePreCartOfferProductButton;
